import { render, staticRenderFns } from "./WinRate.vue?vue&type=template&id=1077139e&scoped=true"
import script from "./WinRate.vue?vue&type=script&lang=js"
export * from "./WinRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1077139e",
  null
  
)

export default component.exports